import React from "react";
import BrandMark from "./BrandMark";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-cream-50 border-t border-cream-300 py-12"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <BrandMark variant="icon-only" size="sm" testId="footer-icon" />
                    <div className="text-center md:text-left">
                        <BrandMark variant="wordmark" size="md" testId="footer-wordmark" />
                        <p className="font-sans italic text-ink-500 text-xs font-light tracking-[0.18em] mt-1">
                            Haus der Tinte · دار المداد
                        </p>
                    </div>
                </div>

                <p className="text-[11px] tracking-[0.24em] uppercase text-ink-500 font-light">
                    © {year} · Mit Liebe gemacht in Deutschland
                </p>
            </div>
        </footer>
    );
}
